define([
], function () {
  'use strict';
  const TYPE = Object.freeze({
    SPINNER: 'spinner'
  });

  return TYPE;
});
